<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div>
  <div class="row content" #searchResult id="searchResult" *ngIf="!history">

    <div [ngClass]="{'col-md-5 pr-01': resultdiv ,'col-md-9 pr-1 pr-01': !resultdiv }">
      <div class="col wccard py-2 mb-3px">
        <div class="row mb-3px">
          <div class="col d-flex" [ngClass]="{'justify-content-between':!resultdiv}">
            <i class="fas fa-arrow-left mr-2 mt-2 pointer" *ngIf="resultdiv"
            (click)="resultdiv=false ; searchresult =[]"></i>   <span class="f-18 mb-0 font-weight-500 d-flex justify-content-between mt-3px"> Sourcing Toolbox
            </span>
            <span class="wc-btn btnreset" *ngIf="!resultdiv" (click)="showHistory();"> History </span>
          </div>
        </div>
      </div>
      <div class="col wccard mb-3px pb-8">
        <div class="row mb-4">
          <div class="col">
            <label class="font-weight-400 f-14 mb-1 mt-3">Job Title </label>
            <div class="position-relative">
              <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions" [style]="{'width':'90%'}"
                (onKeyUp)="OnEnterAddChip($event , 'Job Title')" placeholder = "Type minimum 3 character to get suggestions"
                (onSelect)="selectAutoCompleteChip($event, 'Job Title')" (onUnselect)="UnselectAutoCompleteChip($event,'Job Title')"
                (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
            </div>
          </div>
        </div>
        <div class="row mb-4 mr-4" *ngIf="recommendedjobtitle.length>0">
          <div class="col">
            <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
              title="{{jobtitle}}">
              <div class="chipname" name="jobtitle">{{jobtitle}}</div>
              <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                  (click)="AddChipValueToAutoComplete(i , jobtitle, 'Job Title');"></i> </div>
            </div>
          </div>
        </div>


        <div class="row mb-3">
          <div class="col">
            <p class="font-weight-400 f-14 mb-1">Preferred Skills </p>
            <div class="position-relative">
              <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                [style]="{'width':'90%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 character to get suggestions"
                (onKeyUp)="OnEnterAddChip($event , 'Skill')"  (onUnselect)="UnselectAutoCompleteChip($event,'Skill')"
                (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
            </div>
          </div>
        </div>

        <div class="row mb-4 mr-4" *ngIf="recommendedskills.length>0">
          <div class="col">
            <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
              title="{{skills}}">
              <div class="chipname" name="skills">{{skills}}</div>
              <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                  (click)="AddChipValueToAutoComplete(i , skills, 'Skill');"></i> </div>
            </div>
          </div>
        </div>

        <!---------------------------------------------Mandatory Skills --------------------------------------------->
        <div class="row mb-3">
          <div class="col">
          <p class="font-weight-400 f-14 mb-1">Mandatory Skills </p>
          <div class="position-relative">
            <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption" [style]="{'width':'90%'}"
              (onKeyUp)="OnEnterAddChip($event , 'Mandatory Skill')"  (onUnselect)="UnselectAutoCompleteChip($event,'Skill')"
              (onSelect)="selectAutoCompleteChip($event, 'Skill')" placeholder = "Type minimum 3 character to get suggestions"
              (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
          </div>
        </div>
        </div>
        <div class="row mb-4 mr-4" *ngIf="recommendedskills.length>0">
          <div class="col">
            <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
              title="{{skills}}">
              <div class="chipname" name="skills">{{skills}}</div>
              <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                  (click)="AddChipValueToAutoComplete(i , skills, 'Mandatory Skill');"></i> </div>
            </div>
          </div>
        </div>
        <!---------------------------------------------Mandatory Skills --------------------------------------------->
        <div class="row mb-4">
          <div class="col">
                <p class="font-weight-400 f-14 mb-1">Industry</p>
            <div class="position-relative">
              <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption" field="industry_name"
                [style]="{'width':'90%'}" (completeMethod)="searchAutoCompletedData($event , 'Industry')"  placeholder = "Type minimum 3 character to get suggestions"
                [multiple]="true"></p-autoComplete>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col">
            <p class="font-weight-400 f-14 mb-1">Target Companies</p>
            <div class="position-relative">
              <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'90%'}"
                (onKeyUp)="OnEnterAddChip($event , 'Company')" placeholder = "Type minimum 3 character to get suggestions" field="company_name"
                (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                <ng-template let-companies pTemplate="item">
                  <div class="country-item">
                      <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                      <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                  </div>
              </ng-template>
              </p-autoComplete>

            </div>
          </div>
        </div>



        <div class="row mb-8">
          <div class="col">
            <p class="font-weight-400 f-14 mb-1">Location</p>
            <div class="position-relative">
              <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'90%'}"
                (onKeyUp)="OnEnterAddChip($event , 'Location')" placeholder = "Type minimum 3 character to get suggestions"
                (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
            </div>
          </div>
        </div>

        <div *ngIf="resultdiv">
          <button data-testid="auto-app-smartsearch-button-1" class="btn-trms-small m-auto" (click)="skipbooleanstring('all','update')">Update</button>
          &nbsp; &nbsp;
        </div>

        <div class="mb-3 mt-3 f-14 formError" *ngIf="FormError"> <br /> Please select at least 3 skills (1 Preferred Skill compulsory) & 1 Jobtitle
          to generate boolean string. </div>


      <div *ngIf="!resultdiv">
        <div class="mb-3">
          <ul class="nav nav-pills">
            <li class="nav-item mr-4" title="Search across the web">
              <a data-testid="auto-app-smartsearch-a-1" class="nav-link" id="pills-globe-tab" data-bs-toggle="pill" href="#pills-globe" role="tab" aria-controls="pills-globe"
                aria-selected="true">
                <span class="mr-3">
                  <img src="../../../assets/search/globe.png" class="test321 img-fluid" alt="">
                  <img src="../../../assets/search/globe-a.png" class="test123 img-fluid" alt="">
                </span>
              </a>
            </li>
            <li class="nav-item  mr-4" title="Indeed">
              <a data-testid="auto-app-smartsearch-a-2" class="nav-link" id="pills-Indeed-tab" data-bs-toggle="pill" href="#pills-Indeed" role="tab" aria-controls="pills-Indeed"
                aria-selected="false">
                <span class="mr-3">
                  <img src="../../../assets/search/indeed.png" class="test321 img-fluid" alt="">
                  <img src="../../../assets/search/indeed-a.png" class="test123 img-fluid" alt="">
                </span>
              </a>
            </li>
            <li class="nav-item mr-4" title="LinkedIn">
              <a data-testid="auto-app-smartsearch-a-3" class="nav-link" id="pills-LinkedIn-tab" data-bs-toggle="pill" href="#pills-LinkedIn" role="tab"
                aria-controls="pills-LinkedIn" aria-selected="false">
                <span class="mr-3">
                  <img src="../../../assets/search/linkedin.png" class="test321 img-fluid" alt="">
                  <img src="../../../assets/search/linkedin-a.png" class="test123 img-fluid" alt="">
                </span>
               </a>
            </li>
            <li class="nav-item  mr-4" title="LinkedIn Recruiter">
              <a data-testid="auto-app-smartsearch-a-4" class="nav-link" id="pills-Recruiter-tab" data-bs-toggle="pill" href="#pills-Recruiter" role="tab"
                aria-controls="pills-Recruiter" aria-selected="false">
                <span class="mr-3">
                  <img src="../../../assets/search/recruiter.png" class="test321 img-fluid" alt="">
                  <img src="../../../assets/search/recruiter-a.png" class="test123 img-fluid" alt="">
                </span>
               </a>
            </li>

            <li class="nav-item  mr-4" title="Aegis">
              <a data-testid="auto-app-smartsearch-a-5" class="nav-link" id="pills-Aegis-tab" data-bs-toggle="pill" href="#pills-Aegis" role="tab"
                aria-controls="pills-Aegis" aria-selected="false">
                <span class="mr-3">
                  <img src="../../../assets/search/aegis.png" class="test321 img-fluid" alt="">
                  <img src="../../../assets/search/aegis-a.png" class="test123 img-fluid" alt="">
                </span>
               </a>
            </li>
          </ul>
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade" id="pills-globe" role="tabpanel" aria-labelledby="pills-globe-tab">
            <p>
              We showcase public profiles from across the web that match your search
            </p>
            <button data-testid="auto-app-smartsearch-button-2" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('all')">Search</button> &nbsp; &nbsp;
            </div>

            <div class="tab-pane fade" id="pills-Indeed" role="tabpanel" aria-labelledby="pills-Indeed-tab">
              <p>
               We'll generate the right boolean search string for Indeed to ensure you get the right results.
              </p>
            <p>Disclaimer: To user Indeed you must have a license and be logged in.'
             </p>
              <button data-testid="auto-app-smartsearch-button-3" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('Indeed')">Search</button> &nbsp; &nbsp;
            </div>

            <div class="tab-pane fade" id="pills-LinkedIn" role="tabpanel" aria-labelledby="pills-LinkedIn-tab">
              <p>
               We'll generate the right boolean search string for LinkedIn to ensure you get the right results. Make sure to add the company filter on LinkedIn for accurate results
              </p>
              <button data-testid="auto-app-smartsearch-button-4" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('LinkedIn')">Search</button> &nbsp; &nbsp;
            </div>

            <div class="tab-pane fade" id="pills-Recruiter" role="tabpanel" aria-labelledby="pills-Recruiter-tab">
              <p>
                We'll generate the right boolean search string for LinkedIn Recruiter to ensure you get the right results. Make sure to add the company filter on LinkedIn for accurate results.
              </p>
              <p>
                Disclaimer: To user LinkedIn Recruiter you must have a license and be logged in.'</p>
              <button data-testid="auto-app-smartsearch-button-5" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('LinkedIn Recruiter')">Search</button> &nbsp; &nbsp;
            </div>

            <div class="tab-pane fade" id="pills-Resume" role="tabpanel" aria-labelledby="pills-Resume-tab">
              <button data-testid="auto-app-smartsearch-button-6" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('Resume')">Search</button> &nbsp; &nbsp;
            </div>

            <div class="tab-pane fade" id="pills-Aegis" role="tabpanel" aria-labelledby="pills-Aegis-tab">
              <button data-testid="auto-app-smartsearch-button-7" class="btn-trms-small m-auto" (click)="searchwithoutBoolean('Aegis')">Search</button> &nbsp; &nbsp;
            </div>
        </div>
      </div>
        <div id='tp mb-6'>
        </div>
      </div>
    </div>

    <!------------------------------------------------ browser column ---------------------------------------------->
    <div class="col-md-3 pl-1" *ngIf="!resultdiv">
      <div class="col wccard py-4 smart-info">
        <div class="col">
          <span class="row">
            <span class="mb-3">
              <span class="f-14 font-weight-500">  What does this help me with ?</span>
            </span>
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> Easily Perform X-Ray search and get candidates across the web in this platform.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">Get Candidates from multiple websites in one platform.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0" >
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">  Narrow down your search and spot candidates with the preferable qualifications and skills.
              </span>
            </div>
          </span>
        </div>
      </div>

      <div class="col wccard py-4 mt-3 smart-info-ffd">

        <div class="col">
          <span class="row">
            <span class="mb-3">
              <span class="f-14 font-weight-500">  Exhausted with Linkedin search Limit ?</span>
            </span>
            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0"> Use this tool to search and view candidates anyways.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0">
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">See Candidates that are not in your network on Linkedin.
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-1">
              <span class="col-md-1 mb-3 pl-0 pr-0" >
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">Faster loading results
              </span>
            </div>

            <div class="col-md-12 d-flex pl-0 mb-3">
              <span class="col-md-1 mb-3 pl-0 pr-0" >
                <i class="fal fa-check mr-2"></i>
               </span>
                <span class="col-md-10 f-14 pl-0">No credits for searching.
              </span>
            </div>
          </span>
        </div>


      </div>

    </div>

    <div class="col-md-7 pl-1" *ngIf="resultdiv">
      <div class="col wccard py-3">
        <p> Show results for Only </p>
        <div class="row">
          <div class="col-4">
            <div class="position-relative">
              <select data-testid="auto-app-smartsearch-select-1" class="wc-form-control nobg" (change)="SelectSearchPlatform($event)" [(ngModel)]="platformselected">
                <option value="All" selected> All </option>
                <option value="LinkedIn"> Linkedin </option>
                <option value="Xing"> Xing </option>
                <option value="AngelList"> AngelList </option>
                <option value="Doximity"> Doximity </option>
                <option value="HealthProfs"> HealthProfs </option>
                <option value="Behance"> Behance </option>
                <option value="Dribbble"> Dribble </option>
                <option value="Quora"> Quora </option>
                <option value="Kaggle"> Kaggle </option>
              </select>
              <span class="selectdrop-down position-absolute tr0"><i class="fas fa-chevron-down"></i> <i
                class="fas fa-chevron-up"></i></span>
            </div>
          </div>
        </div>
        <br />
        <br />

        <div *ngIf="totalcustomresults ==  0"> <br />
          <p>No Result Founds , Please Modify your Search Filter</p>
        </div>

        <div [ngClass]="{'SearchScroll': searchresult.length > 10}" *ngIf="totalcustomresults > 0" >
          <p class="font-weight-500"> {{totalcustomresults}} Candidates Found </p>
          <div *ngFor="let x of searchresult">
            <div class="d-flex">
              <div class="canProfilePic">
                <img *ngIf="x.pagemap.cse_thumbnail" src="{{x.pagemap.cse_thumbnail[0].src}}" alt="None"
                  class="img-search">
                <i class="fas fa-user-circle  fa-5x img-search" *ngIf="!x.pagemap.cse_thumbnail"></i>
              </div>
              <div class="col">
                <a data-testid="auto-app-smartsearch-a-6" href="{{x?.formattedUrl}}" target="_blank" class="font-weight-600 text-capitalize searchTitle"
                  [innerHtml]="x.htmlTitle">
                </a>
                <p><span class="ml7px f-12 font-weight-500" [innerHtml]="x.htmlSnippet"></span></p>
              </div>
            </div>
            <br /><br />
          </div>
        </div>
        <span *ngIf="searchresultnextpage" class="pointer" (click)="nextpage()"> <i class="fas fa-angle-double-right" > </i> More Results
        </span>
      </div>
    </div>
    <!------------------------------------------------ browser column ---------------------------------------------->

  </div>


  <div class="row content" *ngIf="history">
      <div class="col-12 wccard py-1 mb-3px">
          <div class="d-flex justify-content-between mb-1 mt-1">
            <div class="d-flex">
            <i class="fas fa-arrow-left mr-3 mt-1 pointer" (click)="history=false"></i>
             <span class="f-14 mt-3px font-weight-500 d-flex justify-content-between pointer"> History
            </span>
          </div>
          <div class="">

            <div *ngIf="totalcount > 0" class="d-flex">
              <span class="px-2 mr-2 mt-3px">
               <div  *ngIf="total > 10 && totalcount > 9">
                <span class="font-weight-600">{{start+1}}-{{end}}</span> of {{total}} results
               </div>
              </span>
              <span class="px-2 f-20" *ngIf="totalcount > 9" >
                <a data-testid="auto-app-smartsearch-a-7" (click)="start > 0 && pagination('prev')" class="mr-1 text-black"><i class="fas fa-caret-left"></i></a>
                &nbsp;
                <a data-testid="auto-app-smartsearch-a-8" (click)="end < total && pagination('next')" class="ml-1 text-black"><i
                    class="fas fa-caret-right"></i></a>
              </span>
            </div>

          </div>
          </div>
      </div>

      <div class="col-12 wccard mb-3px pb-0 oncardlistHover position-relative mt-01" *ngFor="let history of searchtoolboxhistory;let i = index">
        <div class="d-flex justify-content-between mb-1 mt-4">
          <div class="">
              <span class="pb-0 mb-1 text-capitalize f-14"> {{history.jobtitles }} </span>
              <p class="pb-0 mb-1 text-dis" *ngIf="!history.jobtitles"> Not available</p>
          </div>
          <div class="">
            <span class="mr-1 f-12"><i class="fas fa-clock greybg"> </i> {{history.updatedon}} </span>
          </div>
        </div>

        <div class="row mb-1 mt-1 justify-content-between">
          <div class="col-md-8">
              <span class="pb-0 mb-1">
                <span class="pb-0 mb-0 f-14 mr-2">   <span class="gray-text mr-2"> Preferred Skills </span>
                <span class="f-14">  {{history.preferredskills }}   </span>
                <span class="f-14 text-dis" *ngIf='!history.preferredskills'> Not available  </span> </span>
                </span>
          </div>
          <div class="col-md-4 text-right d-flex justify-content-end position-relative">
           <span class="wc-btn bg-blue onhverNotesEllipsis position-absolute mt-3" (click)="SearchHistoryResult(history)"> Search </span>
          </div>
        </div>

        <div class="row mb-1 justify-content-between">
          <div class="col-md-8">
              <span class="pb-0 mb-1 f-14 mr-2">   <span class="gray-text mr-2"> Mandatory Skills  </span>
              <span class="f-14">  {{history.mandatoryskills }}   </span>
              <span class="f-14 text-dis" *ngIf='!history.mandatoryskills'> Not available  </span></span>
          </div>
        </div>

      <div class="row mb-0">
        <div class="col d-flex justify-content-between mb-1 mt-1 pl-0">
          <div class="col-md-6 mb-1">
            <span class="pb-0 mb-1">
               <span class="gray-text f-14 mr-2"> Company Name  </span>
               <span class="f-14 "> {{history.companies }} </span>
               <span class="f-14 text-dis" *ngIf='!history.companies'> Not available  </span>

              </span>
        </div>
        <div class="col-md-6">
          <span class="pb-0">
            <span class="gray-text f-14 mr-2"> Industry Sector  </span>
            <span class="f-14 " *ngFor="let x of history.industries ; let isLast=last">  {{x.industry_name}}
              {{isLast ? '' : '; '}}
             </span>
            <span class="f-14 text-dis" *ngIf='!history.industries'> Not available  </span>
        </span>
        </div>
        </div>


      </div>

      <div class="row mb-4 justify-content-between">
        <div class="col-md-8">
            <span class="pb-0 mb-1 f-14 mr-2">   <span class="gray-text mr-2"> Location Name  </span>
            <span class="f-14">  {{history.locations }}   </span>
            <span class="f-14 text-dis" *ngIf='!history.locations'> Not available  </span></span>
        </div>
      </div>
  </div>

</div>
